import './CompteClient.scss';

import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import ProfilEntreprise from '../../Client/ProfileEntreprise/ProfilEntreprise';
import PrestationComplementaire from './PrestationComplementaire';

function DonneesPC() {

    const axiosPrivate = useAxiosPrivate();
    const [inputListHNO, setInputListHNO] = useState([]);
    const {setBackdropOpen}=useUtilities();
    const {device}=useWindowSize();
    const [isMontant,setIsMontant] = useState('');
    const { i18n } = useTranslation();
    const [nbrHrsHNOs,setNbrHrsHNOs] = useState();
    const [inputListAstreinte, setInputListAstreinte] = useState([]);
    const role = useRole();

    const getPrestationComplementaire = async () => {
        try {
            setBackdropOpen(true);
            const response1 = await axiosPrivate.get(`/${role}/getMyInfos`,
                {
                    headers:
                    {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                }
            );
            if(role=='esn'){
                setInputListAstreinte(response1?.data?.collaboratorEsn?.esnId?.prestationsComplementaires?.astreintes);
                setInputListHNO(response1?.data?.collaboratorEsn?.esnId?.prestationsComplementaires?.hnos);
                if(response1?.data?.collaboratorEsn?.esnId?.prestationsComplementaires?.rules?.isMontant==false)
                    setIsMontant('Coefficient');
                else
                    setIsMontant('Montant');
                setNbrHrsHNOs(response1?.data?.collaboratorEsn?.esnId?.prestationsComplementaires?.rules?.nbrHrsHNOs);
            }
            else{
                setInputListAstreinte(response1?.data?.collaborator?.esnId?.prestationsComplementaires?.astreintes);
                setInputListHNO(response1?.data?.collaborator?.esnId?.prestationsComplementaires?.hnos);
                if(response1?.data?.collaborator?.esnId?.prestationsComplementaires?.rules?.isMontant==false)
                    setIsMontant('Coefficient');
                else
                    setIsMontant('Montant');
                setNbrHrsHNOs(response1?.data?.collaborator?.companyDataId?.prestationsComplementaires?.rules?.nbrHrsHNOs);
            }
            setBackdropOpen(false);
        }catch (error) {
            setBackdropOpen(false);
            console.log(error.response?.status);

        }
    };

    useEffect(()=>{
        if (role)
            getPrestationComplementaire();
    }, [role]);

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Compte entreprise')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Données profil')} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop' ?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <ProfilEntreprise/>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center'}}>
                        <PrestationComplementaire
                            inputListHNO={inputListHNO}
                            setInputListHNO={setInputListHNO}
                            nbrHrsHNOs={nbrHrsHNOs}
                            isMontant={isMontant}
                            inputListAstreinte={inputListAstreinte}
                            setInputListAstreinte={setInputListAstreinte}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default DonneesPC;